import { OrderStatus } from '../types'

/**
 * 订单状态流转规则
 */
export const OrderStatusTransitions: Record<OrderStatus, OrderStatus[]> = {
  [OrderStatus.DRAFT]: [OrderStatus.PENDING_ASSIGN],

  [OrderStatus.PENDING_ASSIGN]: [OrderStatus.ASSIGNED_TO_CS, OrderStatus.EXCEPTION],

  [OrderStatus.ASSIGNED_TO_CS]: [
    OrderStatus.APPOINTMENT_SET, // 上门检测
    OrderStatus.WAITING_MAIL, // 邮寄检测
    OrderStatus.EXCEPTION,
  ],

  // 上门检测路径
  [OrderStatus.APPOINTMENT_SET]: [OrderStatus.DISPATCHED, OrderStatus.EXCEPTION],
  [OrderStatus.DISPATCHED]: [OrderStatus.IN_PROGRESS, OrderStatus.EXCEPTION],
  [OrderStatus.IN_PROGRESS]: [OrderStatus.INSPECTED, OrderStatus.EXCEPTION],

  // 邮寄检测路径
  [OrderStatus.WAITING_MAIL]: [OrderStatus.MAIL_RECEIVED, OrderStatus.EXCEPTION],
  [OrderStatus.MAIL_RECEIVED]: [OrderStatus.LAB_TESTING, OrderStatus.EXCEPTION],
  [OrderStatus.LAB_TESTING]: [
    OrderStatus.INSPECTED,
    OrderStatus.REJECTED,
    OrderStatus.EXCEPTION,
  ],

  // 通用后续状态
  [OrderStatus.INSPECTED]: [OrderStatus.BILL_GENERATED],
  [OrderStatus.REJECTED]: [OrderStatus.COMPLETED],
  [OrderStatus.BILL_GENERATED]: [OrderStatus.PAID],
  [OrderStatus.PAID]: [OrderStatus.CERT_GENERATED],
  [OrderStatus.CERT_GENERATED]: [OrderStatus.COMPLETED],
  [OrderStatus.COMPLETED]: [],

  [OrderStatus.EXCEPTION]: [
    OrderStatus.ASSIGNED_TO_CS,
    OrderStatus.APPOINTMENT_SET,
    OrderStatus.DISPATCHED,
    OrderStatus.WAITING_MAIL,
    OrderStatus.MAIL_RECEIVED,
    OrderStatus.LAB_TESTING,
  ],
}
